import { FC, useMemo } from 'react';
import { AmlCheckItemData } from '@/redux/models';
import { useTranslation } from 'react-i18next';
import { CopyText, SvgIcon } from '@/components';
import { getShortAddress } from '@/helpers';
import { useCopyToClipboard } from '@/hooks';
import { AmlStatusEnum } from '@/api';
import { RiskBadgeColors } from '@/config';
import cx from 'classnames';
import styles from './GeneralInfo.module.sass';

interface GeneralInfoProps {
  isLoading?: boolean;
  item?: AmlCheckItemData;
}

const GeneralInfo: FC<GeneralInfoProps> = ({ item, isLoading }) => {
  const { t } = useTranslation();
  const [, copy] = useCopyToClipboard();
  const statusIconSuffix = useMemo(() => {
    switch (item?.status) {
      case AmlStatusEnum.SUCCESS:
        return RiskBadgeColors.GREEN;
      case AmlStatusEnum.NEW:
      case AmlStatusEnum.PENDING:
        return RiskBadgeColors.ORANGE;
      default:
        return RiskBadgeColors.RED;
    }
  }, [item]);

  const statusClassList = cx(
    styles.status,
    styles[`status--${statusIconSuffix}`],
  );

  if (isLoading) {
    return (
      <div className={styles.box}>
        <div className={styles.skeleton}>
          <div className={styles.skeletonTitle} />
          <div className={styles.skeletonLine} />
          <div className={styles.skeletonLine} />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.general}>
      <div className={styles.general__title}>
        {t('translation.sidebar_tx_details_title')}
      </div>
      <div className={styles.general__list}>
        <dl>
          <dt>{t('translation.promo_tpl_addr_title')}</dt>
          <dd>
            <CopyText
              className={styles.info}
              text={getShortAddress(item?.address)}
              copyText={item?.address}
            />
          </dd>
        </dl>
        {!!item?.addressOwner && (
          <dl>
            <dt>{t('translation.counterparty_owner_str')}</dt>
            <dd>{item.addressOwner}</dd>
          </dl>
        )}
      </div>
    </div>
  );
};

export default GeneralInfo;
